import { render } from "./SimplePageLayout.vue?vue&type=template&id=3767ef32"
import script from "./SimplePageLayout.vue?vue&type=script&lang=js"
export * from "./SimplePageLayout.vue?vue&type=script&lang=js"

import "./SimplePageLayout.vue?vue&type=style&index=0&id=3767ef32&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__